import { requestLaravel } from "../../../utils/api";
import { ApiResponse, ILookupAPIResp } from "./_models";

export interface ILookupDataResponse {
    [key: string]: ILookupAPIResp;
}
export function getLookupDataByKeys(data_keys: string[], order_by_sequence: boolean = true) {
    return requestLaravel<ApiResponse<ILookupDataResponse>>("/lookups/get-lookup-data-by-keys", {data_keys:data_keys, order_by_sequence:order_by_sequence?1:0});
}